"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WIDGETS_WITHOUT_SIDE_MARGINS = exports.WIDGETS_HAVE_ALWAYS_PADDING = exports.WIDGETS_ADJACENT_PREVIOUS_WIDGET_AS_DEFAULT = void 0;
Object.defineProperty(exports, "WidgetSubtitle", {
  enumerable: true,
  get: function get() {
    return _WidgetSubtitle.default;
  }
});
Object.defineProperty(exports, "WidgetTitle", {
  enumerable: true,
  get: function get() {
    return _WidgetTitle.default;
  }
});
exports.widgetContainerConfig = exports.genericWidgetHeaderTagCalculator = exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _zod = require("zod");

var _classnames = _interopRequireDefault(require("classnames"));

var _getWidgetStyle = require("@insided/deprecated-preact-components/utils/getWidgetStyle");

var _WidgetTitle = _interopRequireDefault(require("./WidgetTitle"));

var _WidgetSubtitle = _interopRequireDefault(require("./WidgetSubtitle"));

var WIDGETS_WITHOUT_SIDE_MARGINS = ['generic_hero', 'banner'];
exports.WIDGETS_WITHOUT_SIDE_MARGINS = WIDGETS_WITHOUT_SIDE_MARGINS;
var WIDGETS_HAVE_ALWAYS_PADDING = ['banner'];
exports.WIDGETS_HAVE_ALWAYS_PADDING = WIDGETS_HAVE_ALWAYS_PADDING;
var WIDGETS_ADJACENT_PREVIOUS_WIDGET_AS_DEFAULT = ['generic_hero', 'topic_banner'];
exports.WIDGETS_ADJACENT_PREVIOUS_WIDGET_AS_DEFAULT = WIDGETS_ADJACENT_PREVIOUS_WIDGET_AS_DEFAULT;

var backgroundColorDisplay = _zod.z.union([_zod.z.literal('config--main-color-brand'), _zod.z.literal('config--main-color-brand-secondary'), _zod.z.literal('solid_color'), _zod.z.literal('none'), _zod.z.undefined()]);

var titleColorDisplay = _zod.z.union([_zod.z.literal('solid_color'), _zod.z.literal('config-header-color'), _zod.z.literal('config--main-color-night'), _zod.z.undefined()]);

var subtitleColorDisplay = _zod.z.union([_zod.z.literal('solid_color'), _zod.z.literal('config-header-color'), _zod.z.literal('config--main-color-night'), _zod.z.undefined()]);

var descriptionColorDisplay = _zod.z.union([_zod.z.literal('solid_color'), _zod.z.literal('config-header-color'), _zod.z.literal('config--main-color-night'), _zod.z.undefined()]);

var widgetContainerConfig = _zod.z.object({
  title: _zod.z.union([_zod.z.string(), _zod.z.undefined()]),
  subtitle: _zod.z.union([_zod.z.string(), _zod.z.undefined()]),
  description: _zod.z.union([_zod.z.string(), _zod.z.undefined()]),
  backgroundColor: _zod.z.union([_zod.z.string(), _zod.z.undefined()]),
  backgroundColorDisplay: backgroundColorDisplay,
  titleColor: _zod.z.union([_zod.z.string(), _zod.z.undefined()]),
  titleColorDisplay: titleColorDisplay,
  subtitleColor: _zod.z.union([_zod.z.string(), _zod.z.undefined()]),
  subtitleColorDisplay: subtitleColorDisplay,
  descriptionColor: _zod.z.union([_zod.z.string(), _zod.z.undefined()]),
  descriptionColorDisplay: descriptionColorDisplay,
  hideSpacingWithUpperWidget: _zod.z.union([_zod.z.boolean(), _zod.z.undefined()]),
  paddingToTopAndBottom: _zod.z.union([_zod.z.boolean(), _zod.z.undefined()]),
  // selectedWidgetPersonalisationOption: z.union([z.string(), z.undefined()]), TODO: Define when BE decides how to send data
  startDateTimestamp: _zod.z.union([_zod.z.number(), _zod.z.null(), _zod.z.undefined()]),
  startDate: _zod.z.union([_zod.z.object({
    date: _zod.z.union([_zod.z.array(_zod.z.date()), _zod.z.null()]),
    hours: _zod.z.union([_zod.z.string(), _zod.z.null()]),
    minutes: _zod.z.union([_zod.z.string(), _zod.z.null()]),
    period: _zod.z.union([_zod.z.string(), _zod.z.null()]),
    error: _zod.z.string()
  }), _zod.z.undefined()]),
  finishDateTimestamp: _zod.z.union([_zod.z.number(), _zod.z.null(), _zod.z.undefined()]),
  finishDate: _zod.z.union([_zod.z.object({
    date: _zod.z.union([_zod.z.array(_zod.z.date()), _zod.z.null()]),
    hours: _zod.z.union([_zod.z.string(), _zod.z.null()]),
    minutes: _zod.z.union([_zod.z.string(), _zod.z.null()]),
    period: _zod.z.union([_zod.z.string(), _zod.z.null()]),
    error: _zod.z.string()
  }), _zod.z.undefined()])
}); // This function calculates the header tag for the widget based on the presence of title and subtitle
// It has assumption that existence tag is h3, which is the case for the current implementation for all widgets


exports.widgetContainerConfig = widgetContainerConfig;

var genericWidgetHeaderTagCalculator = function genericWidgetHeaderTagCalculator(hasWidgetTitle, hasWidgetSubtitle) {
  // Always use proper accessibility hierarchy
  // if both title and subtitle set, they will be h2 and h3, so widget tag should have h4
  if (hasWidgetTitle && hasWidgetSubtitle) {
    return 'h4';
  } else if (hasWidgetTitle || hasWidgetSubtitle) {
    // if either title or subtitle is set, they will be h2, so widget tag should have h3
    return 'h3';
  } // if neither title nor subtitle is set, there will be no header yet, so widget tag should have h2


  return 'h2';
};

exports.genericWidgetHeaderTagCalculator = genericWidgetHeaderTagCalculator;

var WidgetContainer = function WidgetContainer(_ref) {
  var _getBackgroundColorSt, _WIDGETS_ADJACENT_PRE;

  var config = _ref.config,
      widgetName = _ref.widgetName,
      children = _ref.children,
      className = _ref.className,
      entity = _ref.entity,
      boundedContext = _ref.boundedContext;
  var titleStyle = (0, _getWidgetStyle.getTextColorStyle)({
    color: config === null || config === void 0 ? void 0 : config.titleColor,
    colorDisplay: config === null || config === void 0 ? void 0 : config.titleColorDisplay
  });
  var subtitleStyle = (0, _getWidgetStyle.getTextColorStyle)({
    color: config === null || config === void 0 ? void 0 : config.subtitleColor,
    colorDisplay: config === null || config === void 0 ? void 0 : config.subtitleColorDisplay
  });
  if (!config) return null;
  var isCustomBackgroundColor = (config === null || config === void 0 ? void 0 : config.backgroundColorDisplay) === 'solid_color';
  var backgroundStyle = isCustomBackgroundColor ? {
    backgroundColor: config === null || config === void 0 ? void 0 : config.backgroundColor
  } : (_getBackgroundColorSt = (0, _getWidgetStyle.getBackgroundColorStyle)(config)) !== null && _getBackgroundColorSt !== void 0 ? _getBackgroundColorSt : {};
  var trackingProps = entity && boundedContext ? {
    'data-entity': entity,
    'data-bounded-context': boundedContext
  } : {};
  return (0, _preact.h)("section", (0, _extends2.default)({
    role: "group" // This is the "last resort" to structure the content in a way that is accessible to screen readers
    // prefer `role="region"` inside with `aria-labelledby` pointing to the title
    ,
    className: (0, _classnames.default)(className, widgetName, "qa-".concat(widgetName, "-container"), 'homepage-widget-wrapper', {
      'widget-container-spacing': typeof config.paddingToTopAndBottom === 'undefined' ? WIDGETS_HAVE_ALWAYS_PADDING.includes(widgetName) : config.paddingToTopAndBottom,
      'homepage-widget-wrapper--no-side-margins': WIDGETS_WITHOUT_SIDE_MARGINS.includes(widgetName),
      // If hideSpacingWithUpperWidget is set it will override default noSpacing value
      'homepage-widget-wrapper--no-spacing': typeof config.hideSpacingWithUpperWidget === 'undefined' ? (_WIDGETS_ADJACENT_PRE = WIDGETS_ADJACENT_PREVIOUS_WIDGET_AS_DEFAULT.includes(widgetName)) !== null && _WIDGETS_ADJACENT_PRE !== void 0 ? _WIDGETS_ADJACENT_PRE : !!config.hideSpacingWithUpperWidget : config.hideSpacingWithUpperWidget
    }),
    style: backgroundStyle
  }, trackingProps), (0, _preact.h)("div", {
    className: "sitewidth"
  }, (0, _preact.h)("div", {
    className: "col"
  }, (0, _preact.h)(_WidgetTitle.default, {
    content: config.title,
    className: "".concat(widgetName, "__heading"),
    style: titleStyle
  }), (0, _preact.h)(_WidgetSubtitle.default, {
    content: config.subtitle,
    className: "".concat(widgetName, "__subheading"),
    style: subtitleStyle,
    hasWidgetTitle: !!config.title
  }), children)));
};

var _default = WidgetContainer;
exports.default = _default;